export default __webpack_public_path__ + "static/media/question-circle.ab6a026d.svg";